<template>
    <sp-form
        class="mobile-general-form-checkbox"
        :class="[`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''}`, `${notChanged ? 'disable-opacity' : ''}`]"
        ref="elForm"
        v-show="!props.hide"
        :model="formModel"
        :rules="rules"
    >
        <sp-form-item prop="value">
            <sp-checkbox
                v-if="!globalModel.preview"
                v-model="formModel.value"
                @input="onInput"
                :align="props.align"
                :disabled="notChanged"
            >
                {{ i18n(props.text) || i18nLabel }}
                <a v-if="props.linkText && props.linkHref" @click.prevent.stop="onLinkClick">
                    {{ i18n(props.linkText) }}
                </a>
            </sp-checkbox>
            <!-- 预览时的效果 -->
            <PreviewText
                v-else
                :labelText="i18n(props.text) || i18nLabel"
                :textDesc="formModel.value ? '是' : '否' "
            ></PreviewText>
            <sub-title class="mt16 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
        </sp-form-item>
    </sp-form>
</template>
<script>
import { Form, FormItem, Checkbox } from '@ks/sharp-ui';
import { openWebView } from '../../utils/bridge';
import ComponentBase from '../component-base';
import { component } from './props';
import PreviewText from '../component-base/common/preview-text';
import SubTitle from '../component-base/common/sub-title';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SpCheckbox: Checkbox,
        PreviewText,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                value: false,
            },
        };
    },
    computed: {
        rules() {
            const rules = [];
            // 必须为真
            if (this.props.mustTrue) {
                rules.push({
                    // FIXME 用async validator文档中推荐的enum方法校验true似乎无效
                    validator: (rule, value, callback) => {
                        if (value) {
                            return callback();
                        }
                        return callback(new Error(
                            this.i18n(this.props.errMustTrue, this.i18nLabel)
                                || `必须勾选${this.i18nLabel}`
                        ));
                    },
                });
            }
            return {
                value: this.composeRules(this.props, { otherRules: rules }),
            };
        },
    },
    methods: {
        async onLinkClick() {
            // TODO 这里要用bridge方法打开的话实际上可能需要成倍增加的配置
            // 以后考虑把打开webview作为一个新的组件
            if (this.props.linkHref) {
                try {
                    await openWebView({
                        url: this.props.linkHref,
                        type: 'close',
                    });
                } catch (e) {
                    window.open(this.props.linkHref, '_blank');
                }
            }
        },
        onInput($event) {
            this.onValueChange($event);
            this.$emit('user-input');
        },
        onValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.value);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue !== 'boolean') {
                // 默认值逻辑
                this.formModel.value = !!newValue;
                this.onValueChange();
                // this.validate();
                return;
            }

            if (this.formModel.value !== newValue) {
                this.formModel.value = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.validateFailureHandler(e.value[0].message);
                return false;
            }
        },
        clearValidate() {
            this.$refs.elForm.clearValidate();
        },
    },
};
</script>
<style lang="less" scoped>
@import '../../style.less';
.mobile-general-form-checkbox {
    padding: 0 1em;
    /deep/ label {
        color: #222;
    }
    /deep/ .sp-form-item__content {
        line-height: unset;
    }
}
</style>
